import { CircularProgress, Typography, Box } from '@mui/material';

/**
 * An overlay component specifically designed for ticket synchronization
 * Now supports both full-screen overlay and subtle notification modes
 */
const SyncLoadingOverlay = ({ 
  message = 'Syncing with GPM Support...',
  subMessage = 'Please wait while we retrieve the latest information',
  subtle = false
}) => {
  // If subtle mode, show a non-intrusive notification
  if (subtle) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
          padding: '10px 16px',
          maxWidth: '300px',
          display: 'flex',
          alignItems: 'center',
          zIndex: 9999,
        }}
      >
        <CircularProgress 
          size={24} 
          thickness={4} 
          sx={{ 
            marginRight: '12px',
            color: 'primary.main'
          }} 
        />
        <Box>
          <Typography 
            variant="body2" 
            component="p" 
            sx={{ 
              fontWeight: 600,
            }}
          >
            {message}
          </Typography>
          <Typography 
            variant="caption" 
            color="text.secondary"
          >
            {subMessage}
          </Typography>
        </Box>
      </Box>
    );
  }
  
  // Original full-screen overlay for non-subtle mode
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          padding: '32px',
          maxWidth: '400px',
          textAlign: 'center',
        }}
      >
        <CircularProgress 
          size={60} 
          thickness={4} 
          sx={{ 
            marginBottom: '16px',
            color: 'primary.main'
          }} 
        />
        <Typography 
          variant="h5" 
          component="h2" 
          sx={{ 
            fontWeight: 600,
            marginBottom: '8px'
          }}
        >
          {message}
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary"
        >
          {subMessage}
        </Typography>
      </Box>
    </Box>
  );
};

export default SyncLoadingOverlay;